import Login from './Login.json';

const es = {
  Login,
};

export default es;
